import React, { useState, Children, cloneElement } from "react";
import "./modalForm.css";
import Button from "../button/button";
import Row from "../layout/row";
import Grid from "../layout/grid";

export function ModalForm({ handleSubmit, handleClose, titulo, children = [], item = {}, contentStyle = {}, textoBotaoSubmit = "Salvar" }) {
    const [form, setForm] = useState(item);
    const handleChange = (target) => {
        setForm((prevState) => ({ ...prevState, [target.name]: target ? target.value : null }));
    };

    const handleCheckboxChange = ({ target }) => {
        setForm((prevState) => ({ ...prevState, [target.name]: !prevState[target.name] }));
    };

    const handleSave = () => {
        handleSubmit(form);
    };

    return (
        <div>
            <div className="modal">
                <div className="modal-content">
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button className="close-button" type="button" onClick={handleClose}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <h5 style={{ textAlign: "center" }}>{titulo}</h5>
                    <div style={contentStyle}>
                        {Children.map(children, (child) => {
                            const isCheckbox = child.props.type === "checkbox";
                            return cloneElement(child, {
                                key: child.props.name,
                                onChange: (e) => (isCheckbox ? handleCheckboxChange(e) : handleChange(e)),
                                value: form[child.props.name] || "",
                                getTarget: true,
                            });
                        })}
                    </div>
                    {handleSubmit ? (
                        <Row>
                            <Grid cols="6 6 6 6">
                                <Button text={textoBotaoSubmit} type={"success"} event={handleSave} />
                            </Grid>
                            <Grid cols="6 6 6 6">
                                <Button text="Voltar" type={"warning"} event={handleClose} />
                            </Grid>
                        </Row>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
